import './LessonList.less';
import React from 'react';
import LessonIcon from "../../../../widgets/lesson-icon/LessonIcon";


export default function LessonList({lessons}) {

    return <ul className="lesson-list">
        {
            lessons.map(lesson => {
                return <li key={lesson.id}>
                    <div className="icon-holder">
                        <LessonIcon lesson={lesson}/>
                    </div>
                    <div className="lesson-name">{lesson.name}</div>
                </li>;
            })
        }
    </ul>;
}
